module.exports = __webpack_public_path__ + "static/media/wd8.f7964d5f.jpeg";